import { authFetch } from './auth';
import { APP_CONFIG } from './config';

// ─────────────────────────────────────────────────────────────
// FETCH BRANCHES & POSITIONS
// GET /public_applicaitons_form/branches_and_positions
// ─────────────────────────────────────────────────────────────

/**
 * Fetch all branches and their open positions for a given enterprise
 * @param {number|string} enterpriseId - ENTERPRISE_ID from tenant config
 * @returns {Array} - list of branches with positions
 */
export async function fetchBranches(enterpriseId) {
  if (!enterpriseId) throw new Error('ENTERPRISE_ID_MISSING');

  // BRANCHES_URL already has ?route=branches so we append with &
  const url = `${APP_CONFIG.BRANCHES_URL}&ENTERPRISE_ID=${enterpriseId}`;

  let res;
  try {
    res = await authFetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  } catch (networkError) {
    throw new Error(`BRANCHES_NETWORK_ERROR: ${networkError.message}`);
  }

  if (!res.ok) {
    throw new Error(`BRANCHES_FETCH_FAILED_${res.status}`);
  }

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error('BRANCHES_PARSE_FAILED: Response is not valid JSON');
  }

  // Handle both shapes: raw array OR { items: [] }
  return Array.isArray(data) ? data : data?.items ?? [];
}